import { render, staticRenderFns } from "./WalletInfo.vue?vue&type=template&id=e8076800&scoped=true&"
import script from "./WalletInfo.vue?vue&type=script&lang=js&"
export * from "./WalletInfo.vue?vue&type=script&lang=js&"
import style0 from "./WalletInfo.vue?vue&type=style&index=0&id=e8076800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8076800",
  null
  
)

export default component.exports